import React from "react"
import { userLogin } from "react-admin"
import GoogleLogin, { GoogleLoginResponse, GoogleLoginResponseOffline } from "react-google-login"
import { connect } from "react-redux"
import "./LoginPage.css"

const loginSuccess = (props: any) => (response: GoogleLoginResponse | GoogleLoginResponseOffline) => {
    props.userLogin(response)
}

const loginFailure = (props: any) => (error: any) => {
    // tslint:disable-next-line:no-console
    console.log("login failure", error)
}

const LoginPage: React.SFC = (props: any) => (
    <div className="LoginPage">
        <GoogleLogin
            clientId={"327702732289-5ouumefc66vgruh64teu12df9n5r2au7.apps.googleusercontent.com"}
            hostedDomain="virtuallylive.com"
            onSuccess={loginSuccess(props)}
            onFailure={loginFailure(props)}
            cookiePolicy={"single_host_origin"}
        />
    </div>
)

export default connect(undefined, { userLogin })(LoginPage)
